import React from "react";
import { whatsappApi } from "../../constants/urls";
import Anchor from "../UI/anchor";
import "./styles.css";

function WhatsappPricing({ headers, data = [] }) {
  return (
    <div className="whatsapp-pricing">
      <h1>Precios de WhatsApp API para conversaciones</h1>
      <table className="whatsapp-table">
        <thead>
          <tr>
            {headers.map((header) => (
              <th>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr>
              <td style={{ minWidth: "6.5rem" }}>{row.country} </td>
              <td>{row.price}</td>
              <td>{row.duration}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Anchor
        text={"Más información"}
        background={"#109cf1"}
        color={"white"}
        link={whatsappApi}
      />
    </div>
  );
}

export default WhatsappPricing;
